import React from 'react';
import { cn } from '@utils/cn';

interface StatusIndicatorProps {
  color: string;
  label: string;
  subtitle?: string;
  size?: 'sm' | 'md';
  className?: string;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  color,
  label,
  subtitle,
  size = 'sm',
  className = '',
}) => {
  const sizeClasses = {
    sm: 'w-2.5 h-2.5',
    md: 'w-3 h-3',
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
  };

  return (
    <div className={cn('flex items-center space-x-2', className)}>
      {/*
        shrink-0 keeps the dot round. As a flex child with no basis of its own it
        is otherwise free to be compressed when the label beside it is long
        enough to compete for space, and a squashed dot renders as an oval —
        visible as soon as the label wraps at narrow widths.
      */}
      <div
        className={cn('shrink-0 rounded-full', sizeClasses[size])}
        style={{ backgroundColor: color }}
      />
      <div className="flex flex-col">
        <span className={cn('font-normal text-gray-600 dark:text-gray-300', textSizeClasses[size])}>
          {label}
        </span>
        {subtitle && (
          <span className={cn('font-normal text-gray-500 dark:text-gray-400', textSizeClasses[size])}>
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
};